import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function CartDrawer() {
  const { items, count, subtotal, drawerOpen, setDrawerOpen, removeFromCart, updateQuantity } = useCart();

  if (!drawerOpen) return null;

  return (
    <div className="fixed inset-0 z-[60]" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setDrawerOpen(false)} />
      <aside className="absolute top-0 right-0 h-full w-full sm:w-[420px] bg-[#0A0A0A] border-l border-[#D4AF37]/25 flex flex-col">
        <div className="flex items-center justify-between px-6 py-5 border-b border-white/10">
          <div>
            <div className="overline text-[#D4AF37]">Your Cart</div>
            <div className="font-serif text-xl mt-1">{count} {count === 1 ? "item" : "items"}</div>
          </div>
          <button onClick={() => setDrawerOpen(false)} className="text-white/60 hover:text-white text-2xl leading-none w-8 h-8" data-testid="cart-drawer-close" aria-label="Close cart">×</button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {items.length === 0 ? (
            <div className="text-center py-20 text-white/50">Your cart is empty.</div>
          ) : (
            <ul className="space-y-5">
              {items.map((it) => (
                <li key={it.product_id} className="flex gap-4" data-testid={`cart-line-${it.product_id}`}>
                  <div className="w-20 h-20 bg-black flex-shrink-0">
                    <img src={it.image_url} alt={it.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-serif text-base truncate">{it.name}</div>
                    <div className="text-white/55 text-xs mt-1">${it.price.toFixed(2)} each</div>
                    <div className="mt-2 flex items-center gap-2">
                      <button onClick={() => updateQuantity(it.product_id, it.quantity - 1)} className="w-7 h-7 border border-white/20 hover:border-[#D4AF37] text-sm">−</button>
                      <span className="w-8 text-center" data-testid={`cart-qty-${it.product_id}`}>{it.quantity}</span>
                      <button onClick={() => updateQuantity(it.product_id, it.quantity + 1)} className="w-7 h-7 border border-white/20 hover:border-[#D4AF37] text-sm">+</button>
                      <button onClick={() => removeFromCart(it.product_id)} className="ml-auto text-[10px] uppercase tracking-[0.18em] text-white/45 hover:text-[#8B0000]" data-testid={`cart-remove-${it.product_id}`}>Remove</button>
                    </div>
                  </div>
                  <div className="font-serif" data-testid={`cart-linetotal-${it.product_id}`}>${(it.price * it.quantity).toFixed(2)}</div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-white/10 px-6 py-5 space-y-3">
            <div className="flex items-center justify-between">
              <span className="overline text-white/60">Subtotal</span>
              <span className="font-serif text-2xl" data-testid="cart-drawer-subtotal">${subtotal.toFixed(2)}</span>
            </div>
            <p className="text-[10px] text-white/45">Shipping & discounts calculated at checkout.</p>
            <Link
              to="/cart"
              onClick={() => setDrawerOpen(false)}
              className="block w-full bg-[#8B0000] hover:bg-[#A50000] text-white text-center px-6 py-4 text-[11px] uppercase tracking-[0.2em]"
              data-testid="cart-drawer-checkout-btn"
            >
              Go to Checkout
            </Link>
            <button
              onClick={() => setDrawerOpen(false)}
              className="block w-full border border-white/15 text-white/60 hover:border-white/40 hover:text-white px-6 py-3 text-[11px] uppercase tracking-[0.2em]"
            >
              Continue Shopping
            </button>
          </div>
        )}
      </aside>
    </div>
  );
}
